import { useTranslation } from 'react-i18next';
import { openModal } from '~/redux/features/uiState/uiStateSlice';
import { useAppDispatch } from '~/redux/hooks';
import CancelSubscriptionModal from '~myAccount/pages/UserSubscription/CancelSubscriptionModal';

export default function RenewalDateSection({
  renewalDate,
  id,
}: {
  renewalDate: string;
  id: number;
}) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('app');

  return (
    <>
      <div className="flex flex-col gap-1.5x border-t border-gray pt-2x px-3x">
        <div className="flex justify-between">
          <p className="text-title_4"> {t('renewalDate')}</p>
          <button
            className="text-link text-red_dark font-bold"
            onClick={() => dispatch(openModal('cancelSubscriptionModal'))}
          >
            {t('cancelSubscription')}
          </button>
        </div>
        <div className="flex flex-col gap-x">
          <p className="text-body_1 text-gray__dark_1">{renewalDate}</p>
          <p className="text-link text-gray__dark_2">{t('autoRenewal')}</p>
        </div>
      </div>
      <CancelSubscriptionModal renewalDate={renewalDate} id={id} />
    </>
  );
}
